import {
  PASSWORD_MANAGER_MESSAGE,
  PASSWORD_REQUIREMENTS_MESSAGE,
} from "@/lib/auth/passwordErrors";

export default function PasswordRequirements({
  className = "",
  showPasswordManagerHint = true,
}: {
  className?: string;
  showPasswordManagerHint?: boolean;
}) {
  return (
    <div className={`space-y-1 text-xs leading-5 text-slate-500 ${className}`.trim()}>
      <p>{PASSWORD_REQUIREMENTS_MESSAGE}</p>
      {showPasswordManagerHint ? <p>{PASSWORD_MANAGER_MESSAGE}</p> : null}
    </div>
  );
}
